import { http } from 'http';

export default {
  // getSectionDataByEntity: entity => http.get(`/masterdata/filters/stratos/${entity}`),

  getBrands: () => http.get('/catalog/GetBrands'),

  getModelByBrand: mark => http.get(`/catalog/getModelByBrand/${mark}`),

  getVehicleTypeByBrand: mark => http.get(`/catalog/getVehicleTypeByBrand/${mark}`)
};
